import { render, staticRenderFns } from "./QuickFile.vue?vue&type=template&id=3b72357a&"
import script from "./QuickFile.vue?vue&type=script&lang=js&"
export * from "./QuickFile.vue?vue&type=script&lang=js&"
import style0 from "./QuickFile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports